import styled, {
  css,
} from 'styled-components';
import {
  transparentize,
} from 'polished';
import MaskedInput from 'react-text-mask';

type InputProps = {
  width?: string;
  placeholdercolor?: string;
};

export const getInputStyles = (props: InputProps) => {
  const { colors } = props.theme;
  const getFocusShadowColor = () => {
    if (props.iserror) return 'rgba(255, 86, 10, 0.25)';
    if (props.nonShadow) return 'none';
    return transparentize(0.75, colors.primary);
  };

  const getPlaceholderStyle = () => css`
    color: ${props.placeholdercolor || '#c1c1c1'};
    opacity: 1;
  `;

  const getPadding = () => {
    switch (props.spacing) {
      case 'compact':
        return '2px 8px';
      case 'none':
        return '0';
      default:
        return props.padding || '0.375rem 0.75rem';
    }
  };

  return css`
    display: block;
    width: ${props.width || '100%'};
    height: ${props.height || 'calc(2.25rem + 9px)'};
    padding: ${getPadding};
    font-size: 1rem;
    line-height: 1.5;
    color: ${colors.inputColor};
    background-color: #fff;
    background-clip: padding-box;
    border-width: 1px;
    border-style: solid;
    border-color: ${(props.iserror ? colors.danger : '#ced4da')};
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    box-sizing: border-box;


    &::-ms-expand {
      background-color: transparent;
      border: 0;
    }

    &:focus {
      outline: 0;
      box-shadow: 0 0 0 0.2rem ${getFocusShadowColor};
      border-color: ${(props.iserror ? colors.danger : colors.primary)};
      background-color: #fff;
    }

    &::-webkit-input-placeholder {
      ${getPlaceholderStyle}
    }

    &::-moz-placeholder {
      ${getPlaceholderStyle}
    }

    &:-ms-input-placeholder {
      ${getPlaceholderStyle}
    }

    &::-ms-input-placeholder {
      ${getPlaceholderStyle}
    }

    &::placeholder {
      ${getPlaceholderStyle}
    }

    &:disabled,
    &[readonly] {
      opacity: 1;
      background-color: #e9ecef;
      cursor: not-allowed;
    }
  `;
};

export const Input = styled.input`
  ${getInputStyles}
`;
export const Masked = styled(MaskedInput)`
  ${getInputStyles}
`;
